import React from 'react';
import { MessagingView } from '../../../components/shared/MessagingView';
export const Messages = () => {
  return <MessagingView type="buyer" data-id="element-1354" />;
};